import { default as WidgetBox, Props as ImportedProps } from './WidgetBox';
import { default as WidgetBoxContainer } from './WidgetBox.container';

export default WidgetBoxContainer(WidgetBox);
export type Props = ImportedProps;
